import React from 'react';
import { changeAcoordionWidth } from '../../actions/AccordionActions';
import properties from '../../constants/Properties';
import { getTouchPosition } from '../utils/TransformToolUtils';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import platformDetection from '../utils/PlatformDetection';
import hoverManager from '../utils/HoverManager';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import { setButtonsHolderWidth } from '../../actions/MenuActions';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import modeType from '../../constants/ModeConstants';
import apiServiceUtils from '../utils/ApiServiceUtils';
import textSizeUtils from '../utils/TextSizeUtils';
import appParameters from '../utils/AppParameters';
import locales from '../../locales/LocalesManager';

const ResizeAccordionButtonContent = React.createClass({
    getInitialState() {
        return {
            initialWidth: this.props.accordionWidth,
            isOver: false
        };
    },
    componentWillUnmount() {
        this.removeEvents();
    },
    addEvents() {
        if (platformDetection.isTouchableDevice()) {
            document.addEventListener('touchmove', this.onMouseMove);
            document.addEventListener('touchend', this.onMouseUp);

            if (platformDetection.isChromeBook()) {
                document.addEventListener('mousemove', this.onMouseMove);
                document.addEventListener('mouseup', this.onMouseUp);
            }
        } else {
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onMouseUp);
        }
    },
    removeEvents() {
        document.removeEventListener('touchmove', this.onMouseMove);
        document.removeEventListener('touchend', this.onMouseUp);

        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
    },
    onOver() {
        if (!this.isAudioEditor()) {
            if (!this.state.isResizing)
                hoverManager.show(this.refs.holder, 'resizeAccordion');
        } else {
            if (this.props.isLeft) {
                if (audioToolUtils.isLeftSideCollapsed())
                    hoverManager.show(this.refs.holder, 'showRightMenu', 'right');
                else
                    hoverManager.show(this.refs.holder, 'hideRightMenu');
            } else {
                if (this.isCollapsed())
                    hoverManager.show(this.refs.holder, 'showRightMenu', 'left');
                else
                    hoverManager.show(this.refs.holder, 'hideRightMenu');
            }
        }

        this.setState({
            isOver: true
        });
    },
    onOut() {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    isCollapsed() {
        if (this.props.accordionWidth > 0)
            return false;
        else
            return true;
    },
    onKeyDown(e) {
        var delta = 10;
        var newWidth = storeManager.getState().accordion.width;
        const maxLimit = 540;

        if (!newWidth)
            newWidth = properties.BROWSER_WIDTH;

        if (e.keyCode == 37 || e.keyCode == 38) { // Left/Up Key
            newWidth = newWidth + delta;
        } else
        if (e.keyCode == 39 || e.keyCode == 40) { // Right/Down Key
            newWidth = newWidth - delta;
        }

        if (newWidth < properties.BROWSER_WIDTH)
            newWidth = properties.BROWSER_WIDTH;
        else if (newWidth > maxLimit)
            newWidth = maxLimit;

        this.props.dispatch(changeAcoordionWidth(newWidth));
    },
    onMouseDown(e) {
        if (this.isAudioEditor()) {
            if (this.props.isLeft) {
                if (audioToolUtils.isLeftSideCollapsed())
                    this.props.dispatch(setButtonsHolderWidth(properties.BUTTONS_HOLDER_WIDTH));
                else
                    this.props.dispatch(setButtonsHolderWidth(properties.BUTTONS_HOLDER_COLLAPSED_WIDTH));
            } else {
                if (this.isCollapsed())
                    this.props.dispatch(changeAcoordionWidth(properties.BROWSER_WIDTH));
                else
                    this.props.dispatch(changeAcoordionWidth(0));
            }

            audioEditorUtils.checkTimelineWidth(false, -1, true);

            return;
        }

        e.preventDefault();

        var position = getTouchPosition(e);

        this.setState({
            initialWidth: this.props.accordionWidth,
            initialX: position.x,
            isResizing: true
        });

        this.addEvents();

        hoverManager.hide();
    },
    onMouseMove(e) {
        if (this.isAudioEditor())
            return;

        e.preventDefault();

        var position = getTouchPosition(e);

        if (this.state.isResizing == true) {
            const deltaX = this.state.initialX - position.x;
            var newWidth = this.state.initialWidth + deltaX;
            const maxLimit = 540;

            if (newWidth < properties.BROWSER_WIDTH)
                newWidth = properties.BROWSER_WIDTH;
            else if (newWidth > maxLimit)
                newWidth = maxLimit;

                this.props.dispatch(changeAcoordionWidth(newWidth));
        }
    },
    onMouseUp(e) {
        if (textSizeUtils.isTextEditMode())
            return;

        if (this.isAudioEditor())
            return;

        if (!platformDetection.isIOS())
            e.preventDefault();

        this.setState({
            isResizing: false
        });

        this.removeEvents();
    },
    isAudioEditor() {
        if (audioToolUtils.isAudioTool())
            return true;
        else
            return this.props.showAudioEditor;
    },
    render () {
        if (this.props.contextMode == modeType.FREEHAND_CONTEXT || this.props.contextMode == modeType.LINE_CONTEXT || this.props.contextMode == modeType.ANIMATION_CONTEXT)
            return (<div/>);

        var buttonWidth = 35;
        var buttonHeight = 35;
        var toolBarWidth = audioToolUtils.isAudioTool() ? 0 : properties.MAIN_MENU_WIDTH;

        var resizeButtonStyle = {
            position: 'absolute',
            top: this.props.windowHeight / 2 - buttonHeight / 2,
            left: this.props.windowWidth - this.props.accordionWidth - buttonWidth - 5 - toolBarWidth,
            width: buttonWidth,
            height: buttonHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            borderRadius: 50,
            background: 'white'
        };

        var iconColor = 'black';

        if (this.state.isOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        var element1;
        var iconStyle

        if (!this.isAudioEditor()) { // is Cartoonist
            var slideViewerHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + properties.SLIDE_VIEWER_LIST_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP + properties.SLIDE_VIEWER_BOTTOM_GAP;
            buttonWidth = properties.MAIN_RESIZE_BUTTON_WIDTH;
            buttonHeight = 25;

            resizeButtonStyle = {
                position: 'absolute',
                top: (this.props.windowHeight - slideViewerHeight) / 2 - buttonHeight / 2,
                left: this.props.windowWidth - this.props.accordionWidth - toolBarWidth - buttonWidth,
                width: buttonWidth,
                height: buttonHeight,
                overflowX: 'hidden',
                overflowY: 'hidden',
                cursor: 'e-resize',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                userDrag: 'none'
            };

            iconStyle = {
                position: 'absolute',
                top: 0,
                left: 2
            };

            element1 = <img alt='' aria-hidden='true' style={iconStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/expand_threeDots.svg'}/>
        } else {
            iconStyle = {
                position: 'absolute',
                top: 1,
                left: 11,
                color: iconColor,
                cursor: 'default',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                userDrag: 'none'
            };

            var iconValue = 'fa fa-angle-left fa-2x';

            if (!this.isCollapsed()) {
                iconValue = 'fa fa-angle-right fa-2x';
                iconStyle.left = 14;
            }

            const audioEditorHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + properties.SLIDE_VIEWER_LIST_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP + audioEditorUtils.getAudioEditorHeight() + properties.SLIDE_VIEWER_BOTTOM_GAP;

            if (audioToolUtils.isAudioTool()) {
                var topBarHeight = 0;

                if (platformDetection.isIOSApp())
                    topBarHeight = properties.CLIPART_BUTTON_HEIGHT;

                topBarHeight = topBarHeight + apiServiceUtils.getNoInternetConnectionAlertHeight();

                resizeButtonStyle.top = properties.HEADER_HEIGHT + topBarHeight - buttonHeight;

                if (this.props.isLeft) {
                    if (audioToolUtils.isLeftSideCollapsed()) {
                        resizeButtonStyle.left = 70;
                        iconValue = 'fa fa-angle-right fa-2x';
                        iconStyle.left = 13;
                    } else {
                        resizeButtonStyle.left = properties.BUTTONS_HOLDER_WIDTH;
                        iconValue = 'fa fa-angle-left fa-2x';
                        iconStyle.left = 11;
                    }
                }
            } else
                resizeButtonStyle.top = (this.props.windowHeight - audioEditorHeight) / 2 - buttonHeight / 2;

            element1 = <i style={iconStyle} className={iconValue}></i>;
        }

        if (!this.isAudioEditor()) { // is Cartoonist
            resizeButtonStyle.boxSizing = 'initial';
            resizeButtonStyle.fontSize = 'initial';
            resizeButtonStyle.padding = 0;
            resizeButtonStyle.margin = 0;
            resizeButtonStyle.borderStyle = 'none';

            return (
                <button ref='holder' aria-label={locales.getCaption('resizeAccordion', 'hover')} style={resizeButtonStyle} onKeyDown={this.onKeyDown} onTouchStart={this.onMouseDown} onMouseDown={this.onMouseDown} onMouseOver={this.onOver} onMouseOut={this.onOut}>
                    {element1}
                </button>
            );
        } else {
            resizeButtonStyle.boxSizing = 'initial';
            resizeButtonStyle.fontSize = 'initial';
            resizeButtonStyle.padding = 0;
            resizeButtonStyle.margin = 0;
            resizeButtonStyle.borderStyle = 'none';

            var ariaLabel = '';

            if (this.props.isLeft) {
                if (audioToolUtils.isLeftSideCollapsed())
                    ariaLabel = locales.getCaption('showRightMenu', 'hover');
                else
                    ariaLabel = locales.getCaption('hideRightMenu', 'hover');
            } else {
                if (this.isCollapsed())
                    ariaLabel = locales.getCaption('showRightMenu', 'hover');
                else
                    ariaLabel = locales.getCaption('hideRightMenu', 'hover');
            }

            return (
                <button ref='holder' aria-label={ariaLabel} style={resizeButtonStyle} onTouchStart={this.onMouseDown} onClick={this.onMouseDown} onMouseOver={this.onOver} onMouseOut={this.onOut}>
                    {element1}
                </button>
            );
        }
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const contextMode = state.menu.contextMode;

    return {
        contextMode
    };
}

export const ResizeAccordionButton = connect(mapStateToProps)(ResizeAccordionButtonContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ResizeAccordionButton.js
 **/